var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page relative flex min-h-screen items-center justify-center overflow-hidden px-3 py-8"},[_c('div',{staticClass:"login-page-backdrop pointer-events-none absolute inset-0",attrs:{"aria-hidden":"true"}}),_c('LoginFormCard',{on:{"close":_vm.closeLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }